import RadioHierarchySelection from '../../../../dataViews/NextTree/plugins/RadioHierarchySelection';

export default {
  makeTreePlugin: canSelectNode =>
    new RadioHierarchySelection({ canSelectNode }),
};
